import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import billionairesReducer from "./billionairesSlice";

export const store = configureStore({
  reducer: {
    billionaires: billionairesReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
